import React from 'react'
import { ActionsContainer, InputSearchContainer, WrapperContainer, WrapperContent, WrapperHeader, WrapperHeaderTitle, WrapperOptions, WrapperOptionsContainer } from './styled'
import Input from 'components/Form/Input'
import { Icon } from 'ui/styled'

export default function TableWrapper({
  children,
  title,
  report,
  nosearch,
  options,
  activeOptions,
  setActiveOptions,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Pesquisar',
}) {

  const handleActive = (item) => {
    setActiveOptions(item)

  }
  return (
    <>
      <WrapperContainer>
        <WrapperContent>
          <WrapperHeader>
            {title && <WrapperHeaderTitle>{title}</WrapperHeaderTitle>}
            <WrapperOptionsContainer>
              {
                options?.map((m) => (
                  <WrapperOptions onClick={() => handleActive(m?.type)} active={activeOptions === m?.type}>{m?.title}</WrapperOptions>
                ))
              }
            </WrapperOptionsContainer>
            <ActionsContainer>
              {nosearch ? null :
                <InputSearchContainer>
                  <Input
                    placeholder={searchPlaceholder}
                    holder
                    endIcon={<Icon icon='search-black' />}
                    small
                    value={searchValue}
                    onChange={onSearchChange}
                  />
                </InputSearchContainer>}
            </ActionsContainer>
          </WrapperHeader>
          {children}
        </WrapperContent>
      </WrapperContainer>
    </>
  )
}
